import React from 'react';

import '../Tutorial.css';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";
import Hole from "../Hole";

function EndTurnBattle() {


  const text = 'Now, press the \'End Turn\' button and wait for your opponent to make their turn.';
    return (
        <div>

            <div className='EndTrunBattleTop'></div>
            <div className='EndTrunBattleRight'></div>
            <div className='EndTrunBattleBottom'></div>

            <Hole className={'.endTurnButton'} diameter={300} />

            <TutorialGirl position={'Left'}/>
            <div className='tutorialContainer tutorialTopContainerEndTurn'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>

        </div>

    );
}

export default EndTurnBattle;
